<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          <span>Edit Control Log</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-autocomplete
                ref="therapy_session"
                outlined
                v-model="form.therapy_session_id"
                :items="therapySessionItems"
                label="Therapy Session"
                prepend-inner-icon="mdi-account-heart"
                clearable
                :error-messages="errors.therapy_session_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="therapist"
                outlined
                v-model="form.therapist_id"
                :items="therapistItems"
                label="Therapist"
                prepend-inner-icon="mdi-doctor"
                clearable
                :error-messages="errors.therapist_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.device_id"
                outlined
                label="Device ID"
                prepend-inner-icon="mdi-devices"
                :error-messages="errors.device_id"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-select
                v-model="form.action"
                outlined
                :items="actionItems"
                label="Action *"
                prepend-inner-icon="mdi-cog"
                :error-messages="errors.action"
              ></v-select>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.speed"
                outlined
                label="Speed (km/h)"
                prepend-inner-icon="mdi-speedometer"
                type="number"
                step="0.01"
                :error-messages="errors.speed"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.unweighting_percentage"
                outlined
                label="Unweighting Percentage (%)"
                prepend-inner-icon="mdi-weight"
                type="number"
                step="0.01"
                :error-messages="errors.unweighting_percentage"
              ></v-text-field>
            </v-col>
            <v-col sm="12">
              <v-textarea
                v-model="form.description"
                outlined
                label="Description"
                prepend-inner-icon="mdi-text"
                rows="3"
                :error-messages="errors.description"
              ></v-textarea>
            </v-col>
            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-btn
            :loading="isLoading"
            :disabled="isLoading"
            color="primary"
            rounded
            dark
            @click="save"
          >
            Update Control Log
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "@/axios";
export default {
  name: "ControlLogEditPage",
  data() {
    return {
      form: {},
      isLoading: false,
      therapySessionItems: [],
      therapistItems: [],
      actionItems: [
        { text: 'Speed Increase', value: 'speed_increase' },
        { text: 'Speed Decrease', value: 'speed_decrease' },
        { text: 'Emergency Stop', value: 'emergency_stop' },
        { text: 'Pause Session', value: 'pause_session' },
        { text: 'Resume Session', value: 'resume_session' },
        { text: 'Unweighting Change', value: 'unweighting_change' },
        { text: 'Direction Change', value: 'direction_change' },
        { text: 'Session Start', value: 'session_start' },
        { text: 'Session End', value: 'session_end' },
        { text: 'Safety Check', value: 'safety_check' },
      ],
    };
  },
  computed: {
    errors() {
      return this.$store.getters['errors/getErrors'];
    },
  },
  mounted() {
    this.getMasters();
    this.getData();
  },
  methods: {
    async getMasters() {
      await axios
        .get(`masters?context=control_log`)
        .then((masters) => {
          masters = masters.data;
          //Therapy Sessions
          masters.therapy_sessions.forEach((session) => {
            this.therapySessionItems.push({
              id: session.id,
              text: `Session #${session.id} - ${session.patient ? session.patient.first_name + ' ' + session.patient.last_name : 'N/A'}`,
              value: session.id,
            });
          });
          //Therapists
          masters.therapists.forEach((therapist) => {
            this.therapistItems.push({
              id: therapist.id,
              text: therapist.first_name + ' ' + therapist.last_name,
              value: therapist.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          // //window.location.href = "/auth/login";
        });
    },
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.controlLogId;
      axios
        .get(`/control_logs/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          console.log(this.form);
          this.old_json = response.data.data;
        })
        .catch((error) => {
          // redirect to Home Page
          // //window.location.href = "/auth/login";
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        await axios
          .patch(`/control_logs/${this.$route.params.controlLogId}`, this.form)
          .then(async () => {
            await this.saveUserTimestamp(this.old_json, this.form);
          })
          .catch((error) => {
            // redirect to Home Page
            // //window.location.href = "/auth/login";
            console.error("Error updating data:", error);
          });
        this.isLoading = false;
        this.$router.push("/control_logs");
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
};
</script>